<app-header (userLogout)="drawer.toggle(false)" (sideBarToggle)="sideNavActive = !sideNavActive"></app-header>
<div class="main" data-template="standard">
  <mat-drawer-container>
    <mat-drawer #drawer mode="over" [(opened)]="sideNavActive" (closed)="sideNavActive = false">
      <div (click)="sideNavActive = false">
        <a routerLink="/admin/users/search"
           routerLinkActive="active"
           mat-menu-item>
          <mat-icon mat-list-icon>group</mat-icon> Nutzer-Verwaltung
        </a>
        <a routerLink="/admin/customers/search"
           routerLinkActive="active"
           mat-menu-item>
          <mat-icon mat-list-icon>work</mat-icon> Zugang-Verwaltung
        </a>
        <a routerLink="/admin/logs"
           routerLinkActive="active"
           mat-menu-item>
          <mat-icon mat-list-icon>insert_drive_file</mat-icon> Logs
        </a>
      </div>
    </mat-drawer>

    <div class="content">
      <ng-content></ng-content>
    </div>
  </mat-drawer-container>

</div>
<app-footer></app-footer>
